import { render, staticRenderFns } from "./ChangeSignatureComponent.vue?vue&type=template&id=aaae291c&"
import script from "./ChangeSignatureComponent.vue?vue&type=script&lang=js&"
export * from "./ChangeSignatureComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports